import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RolesRepository } from '@app/core/repositories/roles.repository';
import { AppConfig } from '@config/app.config';
import { Rol } from '@shared/interfaces/rol';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiRolesRepository implements RolesRepository {
  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.appConfig.SERVICES.roles.findall.url);
  }

  getItemUser(): Observable<any> {
    return this.http.get(
      this.appConfig.SERVICES.permissions.findbyusername.url
    );
  }

  getItemId(item: any): Observable<any> {
    return this.http.get(
      this.appConfig.SERVICES.roles.findbyid.url + '/' + item
    );
  }

  add(rol: Rol): Observable<any> {
    const data = {
      data: {
        type: 'Rol',
        attributes: {
          name: rol.name,
          description: rol.description,
          permissions: rol.permitions
        }
      }
    };
    return this.http.post(this.appConfig.SERVICES.roles.add.url, data);
  }

  edit(rol: Rol): Observable<any> {
    const data = {
      data: {
        type: 'Rol',
        attributes: {
          name: rol.name,
          description: rol.description,
          permissions: rol.permitions
        }
      }
    };
    return this.http.put(
      this.appConfig.SERVICES.roles.update.url + '/' + rol.id,
      data
    );
  }

  delete(item: any): Observable<any> {
    return this.http.delete(
      this.appConfig.SERVICES.roles.delete.url + '/' + item
    );
  }
}
